<template>
  <h2
    v-if="header && header.length > 0"
    :id="headingId"
    class="heading-xs py-24"
  >
    {{ header }}
  </h2>
  <ul
    v-if="cards.length > 0"
    :aria-labelledby="header ? headingId : undefined"
    class="grid gap-16 grid-cols-2 mt-16 mb-24 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5"
  >
    <li v-for="(card, index) in cards" :key="card.key">
      <ProductCard :card-data="card" :card-index="index" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ListingProduct } from '~/models/ListingProduct.api.model';
import { filter_productCardsByPlanVariant } from '~/utils/general/filter_productCardsByPlanVariant';
import {
  DEFAULT_PLAN_ID,
  DEFAULT_MONTHLY_PAYMENT_PERIOD,
} from '~/utils/pdp/queryParamHelpers';

interface Props {
  products?: ListingProduct[];
  header?: string;
  defaultPlanId?: number;
  bindingPeriodInMonths?: number;
}

const headingId = useId();

const props = withDefaults(defineProps<Props>(), {
  products: undefined,
  header: undefined,
  defaultPlanId: undefined,
  bindingPeriodInMonths: undefined,
});

const planId = computed(() => props.defaultPlanId ?? Number(DEFAULT_PLAN_ID));
const amountMonthlyPayments = computed(
  () => props.bindingPeriodInMonths ?? Number(DEFAULT_MONTHLY_PAYMENT_PERIOD),
);
const bindingPeriodMonths = computed(() =>
  determineSelectedBindingPeriod(amountMonthlyPayments.value),
);

const cards = computed(() => {
  const filtered = filter_productCardsByPlanVariant(
    props.products ?? [],
    planId.value,
    amountMonthlyPayments.value,
    bindingPeriodMonths.value,
  );

  return [...filtered].sort(
    (a, b) => a.product.PopularityIndex - b.product.PopularityIndex,
  );
});
</script>
